<a
  *ngIf="href"
  [href]="disabled ? '' : href"
  [ngClass]="{ 'lx-button--block': block }"
  [attr.id]="buttonId"
  [attr.data-gtm-id]="googleTagManagerId"
  [attr.target]="target"
>
  <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
</a>

<button
  *ngIf="!href"
  [disabled]="disabled"
  (click)="buttonClick.emit($event)"
  [ngClass]="{ 'lx-button--block': block }"
  [attr.id]="buttonId"
  [tabindex]="tabindex"
  [attr.data-gtm-id]="googleTagManagerId"
  [type]="buttonType"
>
  <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
</button>

<ng-template #buttonContent>
  <lx-loading-icon-svg *ngIf="loading" [iconStyle]="buttonStyle" class="lx-button__icon" [ngClass]="'lx-button__icon-' + iconPos"></lx-loading-icon-svg>

  <i
    *ngIf="icon"
    [ngClass]="[icon, 'lx-button__icon-' + iconPos]"
    class="
    {{ 'lx-button__icon ' }}
    {{ iconFill ? 'lx-button__icon--fill ' : '' }}
    {{ iconRounded ? 'lx-button__icon--fill--rounded' : '' }}"
  ></i>
  <i *ngIf="svg" class="{{ 'lx-button__svg lx-button__svg--' + svg + ' lx-button__svg--' + svgColor }}"></i>

  <span
    *ngIf="hasText"
    [class.lx-button__svg__text]="(svg || iconFill) && !textLight"
    [ngClass]="{
      'lx-button__text--bold': iconFill,
      'lx-button__text--uppercase': uppercase,
      'lx-button__text--underlined': isUnderlined
    }"
  >
    {{ text }}<ng-content></ng-content>
  </span>
</ng-template>
